<template>
	<div>
		<Titlebar />
		<p>These settings apply to Recycle Race while there are no competitions running.</p>
		<div v-if="is('error')" class="error">Error fetching global settings.</div>
		<div v-else-if="is('loading')" class="loading">Loading...</div>
		<GlobalEventForm
			v-else
			v-model="form"
			:busy="is('submitting')"
			:changed="changed"
			@submit="onSubmit"
			@reset="onReset"
		/>
	</div>
</template>

<script>
import { GLOBAL_EVENT } from 'recycle-race-common/lib/constants'
import Titlebar from '@/components/Titlebar'
import GlobalEventForm from '@/forms/GlobalEventForm'
import { EventProvider } from '@/lib/dataProvider'
import { pick } from '@/lib/helpers'
import state from '@/mixins/state'
import toast from '@/mixins/toast'

export default {
	name: 'GlobalSettings',
	data() {
		return {
			cached: null,
			form: null,
		}
	},
	computed: {
		changed() {
			return JSON.stringify(this.form) !== this.cached
		},
	},
	methods: {
		setForm(event) {
			this.form = pick(event, 'leaderboards')
			this.cached = JSON.stringify(this.form)
		},
		async getGlobalEvent() {
			this.setState('loading')
			try {
				const event = await EventProvider.get(GLOBAL_EVENT)
				this.setForm(event)
				this.setState('idle')
			} catch (err) {
				this.setState('error')
			}
		},
		async onSubmit() {
			if (this.isnt('submitting')) {
				this.setState('submitting')
				try {
					const event = await EventProvider.update(GLOBAL_EVENT, this.form)
					this.setForm(event)
					this.toast('Successfully updated global settings.')
				} catch (err) {
					this.toastError('Failed to update global settings.')
				}
				this.setState('idle')
			}
		},
		onReset() {
			this.form = JSON.parse(this.cached)
		},
	},
	created() {
		// Download global event on init
		this.getGlobalEvent()
	},
	mixins: [state(), toast],
	components: {
		Titlebar,
		GlobalEventForm,
	},
}
</script>
